import { render, staticRenderFns } from "./ShowOrderDetail.vue?vue&type=template&id=300fffa5&scoped=true&"
import script from "./ShowOrderDetail.vue?vue&type=script&setup=true&lang=js&"
export * from "./ShowOrderDetail.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ShowOrderDetail.vue?vue&type=style&index=0&id=300fffa5&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300fffa5",
  null
  
)

export default component.exports